(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  if (window.__spCatTracking) return;
  window.__spCatTracking = true;

  var NEW_TILES = { '2027-planners': 1, 'sticky-notes-notepads': 1, 'stamping': 1, 'ink': 1 };
  var queue = [];
  var consent = null;

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }
  function deliver(name, props) {
    if (window.__spQA) return;
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }
  function send(name, props) {
    if (consent === true) { deliver(name, props); return; }
    if (consent === false) return;
    if (queue.length < 20) queue.push([name, props]);
  }
  function settle() {
    var a = allowed();
    if (a === null) return;
    consent = a;
    if (a) queue.forEach(function (q) { deliver(q[0], q[1]); });
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  function device() {
    return window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches ? 'mobile' : 'desktop';
  }
  function clean(t) { return (t || '').replace(/\s+/g, ' ').trim().slice(0, 60); }
  function path(a) {
    try { return a.href ? new URL(a.href, location.href).pathname : ''; } catch (e) { return ''; }
  }

  function init(track) {
    if (track.dataset.spCatTracked) return;
    track.dataset.spCatTracked = '1';
    var section = track.closest('.shopify-section') || track.parentElement;
    var tiles = Array.prototype.slice.call(track.children);
    var cols = Math.max(1, Math.ceil(tiles.length / 2));
    var lastInput = 'swipe', ended = false, seen = false;

    // which input moved the row last (for sp_home_category_end.via)
    section.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-sp-cat-prev], [data-sp-cat-next]')) lastInput = 'arrow';
    }, true);
    track.addEventListener('pointerdown', function (e) { lastInput = e.pointerType === 'touch' ? 'swipe' : 'drag'; });
    track.addEventListener('keydown', function () { lastInput = 'key'; });
    track.addEventListener('wheel', function () { lastInput = 'wheel'; }, { passive: true });

    track.addEventListener('scroll', function () {
      if (ended) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max > 1 && track.scrollLeft >= max - 2) {
        ended = true;
        send('sp_home_category_end', { via: lastInput, device: device() });
      }
    }, { passive: true });

    // bubble phase: a click swallowed after a drag never arrives
    track.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented) return;
      var tile = tiles.filter(function (t) { return t.contains(a); })[0];
      if (!tile) return;
      // VISUAL position: the CSS reorders tiles (Popular Brands sits bottom-right
      // of the first view), so DOM order is not what the shopper saw.
      var vis = tiles.slice().sort(function (a, b) { return (a.offsetTop - b.offsetTop) || (a.offsetLeft - b.offsetLeft); });
      var i = vis.indexOf(tile);
      var keyEl = tile.matches('[data-sp-cat]') ? tile : tile.querySelector('[data-sp-cat]');
      var key = keyEl ? keyEl.getAttribute('data-sp-cat') : '';
      send('sp_home_category_click', {
        // the block prints its name twice (.subheading + .product-block__title): read one
        label: clean((tile.querySelector('.product-block__title') || a).textContent),
        target: path(a),
        position: i + 1,
        row: i < cols ? 1 : 2,
        column: (i % cols) + 1,
        is_new_tile: !!NEW_TILES[key],
        scrolled: track.scrollLeft > 1,
        device: device()
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (seen || !en.isIntersecting) return;
          seen = true; io.disconnect();
          send('sp_home_category_view', { tiles: tiles.length, device: device() });
        });
      }, { threshold: 0.5 });
      io.observe(track);
    }
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-cat-track]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
